import type { DecompositionNode } from 'api/data/projects/types';

import { LOADING_SUFFIX, TREE_ID_SEP } from '../constants';
import type { RichTreeItem } from '../types';

export function makeTreeId(parentTreeId: string | null, dataNodeId: string): string {
  return parentTreeId ? `${parentTreeId}${TREE_ID_SEP}${dataNodeId}` : dataNodeId;
}

export function toTreeItem(
  node: DecompositionNode,
  parentTreeId: string | null = null,
  titlePlaceholder?: string
): RichTreeItem {
  const autoId = node.subtitle ?? '';
  const title = node.title ?? '';
  const treeId = makeTreeId(parentTreeId, node.id);
  const displayTitle = title || titlePlaceholder || '';
  return {
    id: treeId,
    dataNodeId: node.id,
    title,
    autoId,
    titlePlaceholder,
    label: autoId ? `${autoId}  ${displayTitle}` : displayTitle,
    children: node.hasChildren
      ? [{ id: `${treeId}${LOADING_SUFFIX}`, dataNodeId: '', title: '', autoId: '', label: 'Loading…' }]
      : undefined
  };
}
